"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseWorkspaceSubmitRefusal = exports.formatWorkspaceSubmitRefusal = exports.WORKSPACE_SUBMIT_REFUSAL_CODES = exports.AGENT_SUBMIT_REFUSAL_CODES = void 0;
const mounts_1 = require("./mounts");
exports.AGENT_SUBMIT_REFUSAL_CODES = [
    "invalid_request",
    "invalid_directive",
    "venue_not_supported",
    "workspace_layout",
    "mount_roots_unset",
    "mount_roots_invalid",
    "mount_table_unreadable",
    "host_path_unresolvable",
    "host_path_changed",
    "outside_agent_base_path",
    "outside_mount_roots",
    "mode_exceeds_mount_root",
    "control_path",
    "submount_on_login_node",
    "autofs_on_login_node",
    "control_dir_unwritable",
    "scheduler_refused",
    "control_file_invalid",
    "local_limits_unavailable",
    "local_host_busy",
    "docker_daemon_in_vm",
    "docker_endpoint_refused",
    "local_execution_needs_local_executor",
];
exports.WORKSPACE_SUBMIT_REFUSAL_CODES = [
    ...mounts_1.MOUNT_REFUSAL_REASONS,
    "overlaps_workspace_tree",
    ...exports.AGENT_SUBMIT_REFUSAL_CODES,
];
const FIELD = /^[A-Za-z0-9_.]{1,64}$/;
const SUMMARY = /^refused:([a-z_]+)(?: mount=([0-9]{1,2}))?(?: field=([A-Za-z0-9_.]{1,64}))?: ([\s\S]*)$/;
const formatWorkspaceSubmitRefusal = (refusal) => {
    if (refusal.index !== null &&
        (!Number.isInteger(refusal.index) ||
            refusal.index < 0 ||
            refusal.index > 99)) {
        throw new RangeError("a refusal index is an integer from 0 to 99");
    }
    if (refusal.field !== null && !FIELD.test(refusal.field)) {
        throw new RangeError("a refusal field uses only letters, digits, _ and .");
    }
    const index = refusal.index === null ? "" : ` mount=${refusal.index}`;
    const field = refusal.field === null ? "" : ` field=${refusal.field}`;
    return `refused:${refusal.code}${index}${field}: ${refusal.detail}`;
};
exports.formatWorkspaceSubmitRefusal = formatWorkspaceSubmitRefusal;
const parseWorkspaceSubmitRefusal = (summary) => {
    var _a;
    if (typeof summary !== "string")
        return null;
    const match = SUMMARY.exec(summary);
    if (match === null)
        return null;
    if (!exports.WORKSPACE_SUBMIT_REFUSAL_CODES.includes(match[1]))
        return null;
    return {
        code: match[1],
        index: match[2] === undefined ? null : Number(match[2]),
        field: (_a = match[3]) !== null && _a !== void 0 ? _a : null,
        detail: match[4],
    };
};
exports.parseWorkspaceSubmitRefusal = parseWorkspaceSubmitRefusal;
